<div class="modalCancel">
  <div class="backArrowSection">
    <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <div class="description-img">
    <ion-icon name="alert-circle-outline"></ion-icon>
  </div>

  <div class="title">{{ 'newPhotoValidation' | translate }}</div>

  <span class="description">
    {{ 'newPhotoNotApprovedDescription' | translate }}
  </span>
  
  <div style="border:1px solid var(--ion-background-color); display: flex; justify-content: center;">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button (click)="discard()" class="buttonShadow" expand="full" shape="round" fill="solid" color="primary">
            {{ 'discard' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-button (click)="ToUse()" class="buttonShadow" expand="full" shape="round" fill="outline" color="primary">
            {{ 'useAndLoseSeal' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
